// New file: PartyAddRole.js

import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { getTrans as t } from "../../Localization/translations";
import Tooltip from "@tippyjs/react";

function PartyAddRole({ onSave, onCancel, currentRoles }) {
  const [newRole, setNewRole] = useState("");

  const handleSubmit = () => {
    const trimmed = newRole.trim();
    if (!trimmed) {
      toast.error("Role name cannot be empty");
      return;
    }
    if (currentRoles.some(r => r.name.toLowerCase() === trimmed.toLowerCase())) {
      toast.error("Role already exists");
      return;
    }
    onSave(trimmed);
  };

  return (
    <div className="container-fluid">
    <div className="card">
      <ToastContainer />
      <div className="card-body">
        <h5>{t("Add New Role Name")}</h5>
         <div className="col-lg-6">

         <label className="col-lg-12 col-form-label required">
                {t("Role Name")}{" "}
                <Tooltip content={t("RoleName_Tooltip")}>
                  <i className="fa fa-light fa-circle-info"></i>
                </Tooltip>
              </label>
        <input
          className="form-control"
          type="text"
          value={newRole}
          onChange={(e) => setNewRole(e.target.value)}
          placeholder={t("Enter role name")}
        />
        </div>
        <div className="text-left py-3">
          <button className="btn btn-primary btn-gradient-primary btn-md" onClick={handleSubmit}>
            {t("Save")}
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onCancel}>
            {t("Cancel")}
          </button>
        </div>
      </div>
    </div>
    </div>
  );
}

export default PartyAddRole;